export default "__VITE_ASSET__COlJWMW5__"